import React from 'react';
import './../App.css';
import './WheelPageSZJP.css';
import JackpotSVG from '../assets/JackpotSVG';
import MiniJackpotAmount from './jackpot/MiniJackpotAmount';

import Weel from './../components/weel/Weel'; // if you still need it
import RouletteTable from './../components/table/Table'; // if you still need it
import { Container, Row, Col } from 'react-bootstrap';
import { io } from 'socket.io-client';

import firstRow from './../components/table/rows/FirstRow.json';
import firstBorder from './../components/table/rows/FirstBorder.json';
import secondRow from './../components/table/rows/SecondRow.json';
import secondBorder from './../components/table/rows/SecondBorder.json';
import thirdRow from './../components/table/rows/ThirdRow.json';
import thirdBorder from './../components/table/rows/ThirdBorder.json';
import fourthRow from './../components/table/rows/FourthRow.json';
import fifthRow from './../components/table/rows/FifthRow.json';
import columnLeft from './../components/table/rows/ColumnLeft.json';
import columnRight from './../components/table/rows/ColumnRight.json';

import bgImage1 from './../images/roulette_rules.jpeg';
import bgImage2 from './../images/bgAdv2.jpg';
import bgImage3 from './../images/bgAdv1.jpg';
// import bgVideo from './../images/bg-ad.mp4';

import sound from './../images/roulette_casino_evianaif-14446.mp3';
import options from './options_ORIG.json';

import { API_URL, SOCKET_URL } from './environment';

import anime from 'animejs';
import mp3Betn from './../images/place_bets.mp3';
import mp3NoBets from './../images/no_more_bets.mp3';
import mp3BetsClos from './../images/bets_closing.mp3';
import mp3Ball from './../images/ball_rolling.mp3';
import mp3BallEnd from './../images/roulette_casino_end.mp3';
import mp3_0 from './../images/numbers/0.mp3';
import mp3_1 from './../images/numbers/1.mp3';
import mp3_2 from './../images/numbers/2.mp3';
import mp3_3 from './../images/numbers/3.mp3';
import mp3_4 from './../images/numbers/4.mp3';
import mp3_5 from './../images/numbers/5.mp3';
import mp3_6 from './../images/numbers/6.mp3';
import mp3_7 from './../images/numbers/7.mp3';
import mp3_8 from './../images/numbers/8.mp3';
import mp3_9 from './../images/numbers/9.mp3';
import mp3_10 from './../images/numbers/10.mp3';
import mp3_11 from './../images/numbers/11.mp3';
import mp3_12 from './../images/numbers/12.mp3';
import mp3_13 from './../images/numbers/13.mp3';
import mp3_14 from './../images/numbers/14.mp3';
import mp3_15 from './../images/numbers/15.mp3';
import mp3_16 from './../images/numbers/16.mp3';
import mp3_17 from './../images/numbers/17.mp3';
import mp3_18 from './../images/numbers/18.mp3';
import mp3_19 from './../images/numbers/19.mp3';
import mp3_20 from './../images/numbers/20.mp3';
import mp3_21 from './../images/numbers/21.mp3';
import mp3_22 from './../images/numbers/22.mp3';
import mp3_23 from './../images/numbers/23.mp3';
import mp3_24 from './../images/numbers/24.mp3';
import mp3_25 from './../images/numbers/25.mp3';
import mp3_26 from './../images/numbers/26.mp3';
import mp3_27 from './../images/numbers/27.mp3';
import mp3_28 from './../images/numbers/28.mp3';
import mp3_29 from './../images/numbers/29.mp3';
import mp3_30 from './../images/numbers/30.mp3';
import mp3_31 from './../images/numbers/31.mp3';
import mp3_32 from './../images/numbers/32.mp3';
import mp3_33 from './../images/numbers/33.mp3';
import mp3_34 from './../images/numbers/34.mp3';
import mp3_35 from './../images/numbers/35.mp3';
import mp3_36 from './../images/numbers/36.mp3';
import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa';

import axios from 'axios';



class App extends React.Component {
  // 1) Basket bet (European style version: 4-number basket)
  basketBet = ["0", "1", "2", "3"];
  
  state = {
    num: "", // winning number
    arr: [], // array of bets
    betsLogL: [],
    betsLogR: [],
    luckyArrL: [],
    luckyArrR: [],
    count: 0, // spins count
    wins: 0, // wins count
    chip: 10, // chip value
    coins: 100000, // coins count
    losses: 0, // losses count
    timer: 0,
    progressPerc: 0,
    bgTimer: 0,
    spinning: false, // the wheel is spinning?
    message: "Put your bets and spin the wheel!", // message
    extArr: [], // trick to push number here if user wins, else empty
    // JSON rows
    firstRow, firstBorder, secondRow, secondBorder, thirdRow, thirdBorder,
    fourthRow, fifthRow, columnLeft, columnRight,

    hot1: 0, hot2: 0, hot3: 0, hot4: 0, hot5: 0,
    cold1: 0, cold2: 0, cold3: 0, cold4: 0, cold5: 0,
    currentSpinId: 0,
    isLoaded: false,
    showAd: false,
    currentBgImage: bgImage1,
    bgImages: [bgImage1, bgImage2, bgImage3],
    curImageInd: 0,
    isTransitioning: false,
    ballPosition: "-163.221px",
    wheelInfoTxt: 'Place your bets',
    winners: [],
    megaJackpot: 0,
    miniJackpot: 0,
    luckyNumberText: '-',
    animJackpotOn: true
  };


    // 2) Define audio objects as class fields (no constructor needed)
    placeYourBetsAudio = new Audio(mp3Betn);
    placeYourBetsAudioNoBets = new Audio(mp3NoBets);
    placeBetsClosAudio = new Audio(mp3BetsClos);
    ballRollingAudio = new Audio(mp3Ball);
    ballRollingAudioEnd = new Audio(mp3BallEnd);
  
    numberAudio0 = new Audio(mp3_0);
    numberAudio1 = new Audio(mp3_1);
    numberAudio2 = new Audio(mp3_2);
    numberAudio3 = new Audio(mp3_3);
    numberAudio4 = new Audio(mp3_4);
    numberAudio5 = new Audio(mp3_5);
    numberAudio6 = new Audio(mp3_6);
    numberAudio7 = new Audio(mp3_7);
    numberAudio8 = new Audio(mp3_8);
    numberAudio9 = new Audio(mp3_9);
    numberAudio10 = new Audio(mp3_10);
    numberAudio11 = new Audio(mp3_11);
    numberAudio12 = new Audio(mp3_12);
    numberAudio13 = new Audio(mp3_13);
    numberAudio14 = new Audio(mp3_14);
    numberAudio15 = new Audio(mp3_15);
    numberAudio16 = new Audio(mp3_16);
    numberAudio17 = new Audio(mp3_17);
    numberAudio18 = new Audio(mp3_18);
    numberAudio19 = new Audio(mp3_19);
    numberAudio20 = new Audio(mp3_20);
    numberAudio21 = new Audio(mp3_21);
    numberAudio22 = new Audio(mp3_22);
    numberAudio23 = new Audio(mp3_23);
    numberAudio24 = new Audio(mp3_24);
    numberAudio25 = new Audio(mp3_25);
    numberAudio26 = new Audio(mp3_26);
    numberAudio27 = new Audio(mp3_27);
    numberAudio28 = new Audio(mp3_28);
    numberAudio29 = new Audio(mp3_29);
    numberAudio30 = new Audio(mp3_30);
    numberAudio31 = new Audio(mp3_31);
    numberAudio32 = new Audio(mp3_32);
    numberAudio33 = new Audio(mp3_33);
    numberAudio34 = new Audio(mp3_34);
    numberAudio35 = new Audio(mp3_35);
    numberAudio36 = new Audio(mp3_36);
  
    // 3) Create a simple boolean to track mute status (also a class field)
    isMuted = false;
  
    // 4) Toggle function
    toggleMute = () => {
      this.isMuted = !this.isMuted;
      this.placeYourBetsAudio.muted = this.isMuted;
      this.placeYourBetsAudioNoBets.muted = this.isMuted;
      this.placeBetsClosAudio.muted = this.isMuted;
      this.ballRollingAudio.muted = this.isMuted;
  
      // forceUpdate to update the button label in the render method
      this.forceUpdate();
    };

  

  // 2) European roulette pockets (37 total)
  rouletteWheelNumbers = [
    0, 32, 15, 19, 4, 21, 2, 25,
    17, 34, 6, 27, 13, 36, 11,
    30, 8, 23, 10, 5, 24, 16, 33,
    1, 20, 14, 31, 9, 22, 18, 29,
    7, 28, 12, 35, 3, 26
  ].reverse();

  // If you want American style with "00", you'd have 38 pockets
  // e.g. ["00", 0, 32, 15, ... 36]

  totalNumbers = 37;                 
  singleSpinDuration = 5000;         
  singleRotationDegree = 360 / 37;   

  // For local usage:
  wheelRef;
  socketServer;
  isBunnersRun = false;

  constructor(props) {
    super(props);
    // Audio ref for the ball/wheel
    this.ballAudioRef = React.createRef();
    this.socketServer = null;
    this.isBunnersRun = false;
  }

  async componentDidMount() {
    document.body.classList.add('wheel-active');

    // 3) Connect to socket
    this.socketServer = io(SOCKET_URL);
    this.socketServer.open();

    this.socketServer.on('connect', () => {
      console.log('connect');
      this.socketServer.emit('authentication', { username: 'sadmin', password: 'Admin776!' });
    });

    this.socketServer.on('authentication_response', (data) => {
      console.log('authentication_response', data);
      this.socketServer.emit('join_room', { room: 'wheel' });
    });

    this.socketServer.on('unauthorized', (data) => {
      console.log('unauthorized', data);
    });

    this.socketServer.on('join_room_response', (data) => {
      console.log('join_room_response', data);
    });
 
    // let hasPlayed = false;
    // let hasPlayedBets = false;
    // let hasPlayBall = false;
 
    // const placeYourBetsAudio = new Audio(mp3Betn);
    // const placeYourBetsAudioNoBets = new Audio(mp3NoBets);
    // const placeBetsClosAudio = new Audio(mp3BetsClos);
    // const ballRollingAudio = new Audio(mp3Ball);


    this.socketServer.on('timer', (data) => {
      const timerSec = data.timer;
      const BEFORE_SPIN_TIME = 165;
      const LOOP_TIME = 180;
      const bgTimer = LOOP_TIME - timerSec;

      // if (timerSec === 10) {
      //   hasPlayBall = false;
      // }

      if (timerSec === 165) {
        this.ballRollingAudio.play()
          .catch(err => {
            console.log('Could not autoplay sound:', err);
          });
        // if (!hasPlayBall) {
        //   ballRollingAudio.play()
        //     .catch(err => {
        //       console.log('Could not autoplay sound:', err);
        //     });
        //     hasPlayBall = true;
        // }
      }

      // if (timerSec === LOOP_TIME) {
      //   hasPlayed = false;
      // }

      if (timerSec === 164) {
        // hasPlayedBets = false;
        this.placeYourBetsAudioNoBets.play()
          .catch(err => {
            console.log('Could not autoplay sound:', err);
          });

        // if (!hasPlayedBets) {
        //   placeYourBetsAudioNoBets.play()
        //     .catch(err => {
        //       console.log('Could not autoplay sound:', err);
        //     });
        //     hasPlayedBets = true;
        // }
      }
      // if (timerSec === 84) {
      //   this.ballRollingAudioEnd.play()
      //     .catch(err => {
      //       console.log('Could not autoplay sound:', err);
      //     });
      // }

      if (timerSec === 155) {
        this.placeBetsClosAudio.play()
          .catch(err => {
            console.log('Could not autoplay sound:', err);
          });
      }

      // Hide ball
      if (timerSec === 1) {
        const ballEl = document.querySelector('.ball');
        if (ballEl) {
          ballEl.style.opacity = 0;
        }
        this.placeYourBetsAudio.play()
          .catch(err => {
            console.log('Could not autoplay sound:', err);
          });
      }

      // Trigger the spin wheel 10 seconds before spinning
      if (timerSec === (BEFORE_SPIN_TIME - 10)) {
        this.beforeSpinWheel();
      }

      // Calculate how many seconds left in the "betting" phase
      let currentTimer = 0;
      if (timerSec < BEFORE_SPIN_TIME) {
        currentTimer = BEFORE_SPIN_TIME - timerSec;
      }
      let progressPerc = currentTimer;

      let infoText = '';
      // ----- Phase 1: Place your bets -----
      if (timerSec > 0 && timerSec <= (BEFORE_SPIN_TIME - 10)) {
        infoText = 'Place your bets';

        // Only play the audio once during this entire phase
        // if (!hasPlayed) {
        //   placeYourBetsAudio.play()
        //     .catch(err => {
        //       console.log('Could not autoplay sound:', err);
        //     });
        //   hasPlayed = true;
        // }
      }
      // ----- Phase 2: Bets are closing (last 9 seconds) -----
      else if (timerSec > (BEFORE_SPIN_TIME - 10) && timerSec < BEFORE_SPIN_TIME) {
        infoText = 'Bets are closing';
        // Audio has already played above, so do nothing here
      }
      // ----- Phase 3: No more bets -----
      else {
        infoText = 'No more bets';
        // if (!hasPlayedBets) {
        //   placeYourBetsAudioNoBets.play()
        //     .catch(err => {
        //       console.log('Could not autoplay sound:', err);
        //     });
        //     hasPlayedBets = true;
        // }
      }
      this.setState({
        progressPerc,
        timer: currentTimer,
        bgTimer,
        currentSpinId: data.spin,
        wheelInfoTxt: infoText,
      });
    });

    // Load helper to set logs & hot/cold
    const loadHistoryAndHotCold = (data) => {
      const currentTimer = this.state.bgTimer;
      // console.log('load history timer', currentTimer);
      if (currentTimer > 5 && currentTimer < 17) {
        return;
      }

      const historyArr = data.history.split(',');
      const historySpinArr = data.spinNumberHistory.split(',');
      const betsLogArrL = [];
      const betsLogArrR = [];

      for (let count = 0; count < historyArr.length; count++) {
        if (count < 5) {
          betsLogArrL.push({
            spinId: historySpinArr[count],
            number: historyArr[count],
          });
        } else {
          betsLogArrR.push({
            spinId: historySpinArr[count],
            number: historyArr[count],
          });
        }
      }

      const hotNumbers = data.hot.split(',');
      const coldNumbers = data.cold.split(',');
      this.setState({
        isLoaded: true,
        betsLogL: betsLogArrL,
        betsLogR: betsLogArrR,
        hot1: hotNumbers[0],
        hot2: hotNumbers[1],
        hot3: hotNumbers[2],
        hot4: hotNumbers[3],
        hot5: hotNumbers[4],
        cold1: coldNumbers[0],
        cold2: coldNumbers[1],
        cold3: coldNumbers[2],
        cold4: coldNumbers[3],
        cold5: coldNumbers[4],
      });
    };

    // 4) On 'spin' event, we get data.prng from server
    this.socketServer.on('spin', (data) => {
      console.log('spin event', data);

      // loadHistoryAndHotCold(data);

      // The server's random number => data.prng
      // Convert to integer if needed
      const serverNumber = parseInt(data.prng, 10);
      // console.log('serverNumber', serverNumber);
      // Spin the wheel & do local logic
      this.spinWheel(serverNumber);
      this.updateNum(serverNumber);

      const self = this;
      setTimeout(async()=>{

        try {
          self[`numberAudio${serverNumber}`].play();
        } catch(err) {
          console.log('Could not autoplay sound:', err);
        };
      }, 11000);


      setTimeout(async()=>{

        // call after each spins
        const injRes = await axios.get(`${API_URL}/jackpots`, {});

        const luckyNumbersSp = (injRes?.data?.length && injRes?.data) || [];
        console.log('JACKPOTS AFTER SPIN', luckyNumbersSp);

        const MAX_JACKPOTS = 10;
        const jackpotsNumber = luckyNumbersSp.length > MAX_JACKPOTS ? MAX_JACKPOTS : luckyNumbersSp.length;

        const luckyArrLsp = [];
        const luckyArrRsp = [];

        for (let count = 0; count < jackpotsNumber; count++) {
          if (count < 5) {
            luckyArrLsp.push({
              spinId: luckyNumbersSp[count].spinNumber,
              number: luckyNumbersSp[count].luckyNumber,
              jackpotType: luckyNumbersSp[count].jackpotType,
            });
          } else {
            luckyArrRsp.push({
              spinId: luckyNumbersSp[count].spinNumber,
              number: luckyNumbersSp[count].luckyNumber,
              jackpotType: luckyNumbersSp[count].jackpotType,
            });
          }
        }

        self.setState({
          luckyArrL: luckyArrLsp,
          luckyArrR: luckyArrRsp,
        });
      }, 16000);
    });

    // 'sync' event
    this.socketServer.on('sync', (data) => {
      // console.log('sync event', data);
      loadHistoryAndHotCold(data);
    });

    this.socketServer.on('luckyNumber', (data) => {
      // console.log('luckyNumber event', data);

      const {luckyNumber} = data;
      
      const extractNumber = (str) => {
        const match = str.match(/-?\d+(\.\d+)?/);
        return match ? Number(match[0]) : '-';
      };
      
      this.setState({
        luckyNumberText: extractNumber(luckyNumber),
      });
    });

// default text 'Play now and be the first to win the MEGA and MINI jackpots'    

    this.socketServer.on('winners', (data) => {
      // console.log('winners event', data);
      const {winners} = data;
      const winnersList = (winners?.length > 5 ? winners.slice(0, 5) : winners) || [];
      this.setState({winners: winnersList});
    });

    this.socketServer.on('jackpots', (data) => {
      // console.log('jackpots event', data);

      const {miniJackpot, megaJackpot} = data;
      this.setState({
        miniJackpot,
        megaJackpot,
      });
    });

    // call after each spins
    const jRes = await axios.get(`${API_URL}/jackpots`, {});

    const luckyNumbers = (jRes?.data?.length && jRes?.data) || [];
    // console.log('JACKPOTS', luckyNumbers);

    const MAX_JACKPOTS = 10;
    const jackpotsNumber = luckyNumbers.length > MAX_JACKPOTS ? MAX_JACKPOTS : luckyNumbers.length;

    const luckyArrL = [];
    const luckyArrR = [];

    for (let count = 0; count < jackpotsNumber; count++) {
      if (count < 5) {
        luckyArrL.push({
          spinId: luckyNumbers[count].spinNumber,
          number: luckyNumbers[count].luckyNumber,
          jackpotType: luckyNumbers[count].jackpotType,
        });
      } else {
        luckyArrR.push({
          spinId: luckyNumbers[count].spinNumber,
          number: luckyNumbers[count].luckyNumber,
          jackpotType: luckyNumbers[count].jackpotType,
        });
      }
    }

    this.setState({
      luckyArrR,
      luckyArrL,
    });
  }

  toggleSound = () => {
    this.setState(
      (prevState) => ({ isMuted: !prevState.isMuted }),
      () => {
        this.placeYourBetsAudio.muted = this.state.isMuted;
        this.placeYourBetsAudioNoBets.muted = this.state.isMuted;
        this.ballRollingAudio.muted = this.state.isMuted;
      }
    );
  };

  componentWillUnmount() {
    if (this.socketServer) {
      this.socketServer.close();
    }
    // clearInterval(this.timerInterval);
    document.body.classList.remove('wheel-active');
  }

  // Utility: find array index from a number
  getRouletteIndexFromNumber = (num) => {
    return this.rouletteWheelNumbers.indexOf(parseInt(num, 10))+1;
  };

  getRotationFromNumber = (num) => {
    const index = this.getRouletteIndexFromNumber(num);
    // console.log('num ind', num, index);
    return this.singleRotationDegree * index;
  };
 
  // Random total rotation for 3 to 5 spins
  getRandomEndRotation = (minSpins, maxSpins) => {

    const numbers = [720, 1080, 1440];
    const randomIndex = Math.floor(Math.random() * numbers.length);
    const randomSteps = numbers[randomIndex];
    return randomSteps;
  };

  getZeroEndRotation = (totalRotation) => {
    return 360 - Math.abs(totalRotation % 360);
  };

  getBallEndRotation = (zeroEndRotation, currentNumber) => {
    return Math.abs(zeroEndRotation) + this.getRotationFromNumber(currentNumber.toString());
  };
 
 

  beforeSpinWheel = () => {
    if (document.querySelector('.ball')) {
      document.querySelector('.ball').style.opacity = 0;
    }

    anime.set([".layer-2", ".layer-4"], { rotate: 0 }); 
  
    const bezier = [0.165, 0.84, 0.44, 1.005];
    const tl = anime.timeline({
      easing: `cubicBezier(${bezier.join(",")})`,
      duration: 10000,  
    });
 
    const totalRotation = 3 * 360;  


    tl.add({
      targets: [".layer-2", ".layer-4"],
      rotate: '+=720',   
      duration: 10000,    
      easing: 'linear',   
    }, 0);
 

  }
  

  spinWheel = (winningNumber) => {
    if (this.state.spinning) return;
    this.setState({ spinning: true, num: winningNumber });
  
 
    // if (this.ballAudioRef.current) {
    //   this.ballAudioRef.current.currentTime = 0;
    //   this.ballAudioRef.current.play().catch(console.warn);
    // }
  
 
    const endDegree = Math.floor(Math.random() * 360) + 1;
    const totalRotation = (3 * 360) + endDegree;  
   


    // calculate the leveling angle (zeroEndRotation)
    const zeroEndRotation = this.getZeroEndRotation(totalRotation);

    // calculate the angle corresponding to the winning number
    const ballTargetRotation = this.getBallEndRotation(zeroEndRotation, winningNumber);

    // calculate additional random revolutions from 3 to 5 full revolutions
    const extraRotation = this.getRandomEndRotation();

    // The final turn of the ball includes additional turns
    const finalBallRotation = extraRotation + ballTargetRotation;

 
    anime.set([".layer-2", ".layer-4"], { rotate: 0 });
    anime.set(".ball-container", { rotate: 0 });
    anime.set(".ball", { translateY: "-163px" });
  
    const bezier = [0.165, 0.84, 0.44, 1.005];
    const tl = anime.timeline({
      easing: `cubicBezier(${bezier.join(",")})`,
      duration: 10000,  
    });

    if (document.querySelector('.ball')) {
      document.querySelector('.ball').style.opacity = 0;
    }
  
 


    // tl.add({
    //   targets: [".layer-2", ".layer-4"],
    //   rotate: totalRotation, 
    //   duration: 10000,
    //   easing: 'easeOutCubic', // Start fast and slow down at the end
    // }, 0);

 

    // tl.add({
    //   targets: ".ball-container",
    //   rotate: -finalBallRotation,
    //   duration: 10000,
    //   keyframes: [
    //     { translateY: 0},
    //   ],
    // }, 0); 


    // const tl = anime.timeline();

tl
  
  // Second animation (layers 2 & 4, 10 seconds)
  .add({
    targets: [".layer-2", ".layer-4"],
    rotate: totalRotation,
    duration: 10000,
    easing: "easeOutCubic"
  })
  // Third animation (ball-container, also 10 seconds)
  // Offset: '-=10000' means "start this when the second animation starts"
  .add({
    targets: ".ball-container",
    rotate: -finalBallRotation,
    duration: 10000,
    keyframes: [
      { translateY: 0 },
    ],
 
  }, "-=10000")
  // First animation (quick +30 rotation, 1 second)
  .add({
    targets: [".layer-2", ".layer-4", ".ball-container"],
    rotate: "+=30",
    duration: 1000,
    easing: "linear"
  });


    // Select all .ball elements
      const balls = document.querySelectorAll(".ball");

      // Function to generate random animation for a given element
      const animateBall = (ball) => {
        const animations = [animationOne, animationTwo, animationThree, animationFour]; 
        // const animations = [animationFour]; 
        const randomAnimation = animations[Math.floor(Math.random() * animations.length)]; // Pick one randomly
        randomAnimation(ball);
      };

      // First Animation
      const animationOne = (target) => {
        anime.timeline().add({
          targets: target,
          duration: 10000,
          keyframes: [
            {
              translateY: -167,  
              opacity: 1,
              easing: 'linear', 
              offset: 0.1
            },
            {
              translateY: -165,  
              easing: 'linear',  
              offset: 0.11
            },
            {
              translateY: -140,  
              easing: 'linear',
              offset: 0.12
            },
            {
              translateY: -130,  
              easing: 'linear',
              offset: 0.13
            },
            {
              translateY: -133,  
              easing: 'linear',
              offset: 0.14
            },
            {
              translateY: -103,  
              easing: 'linear',
              offset: 0.2
            },
            {
              translateY: -143,  
              easing: 'linear',
              offset: 0.3
            },
            {
              translateY: -153,  
              easing: 'linear',
              offset: 0.4
            },
            {
              translateY: -130,  
              easing: 'linear',
              offset: 0.5
            },
            {
              translateY: -120,  
              easing: 'linear',
              offset: 0.55
            },
            {
              translateY: -110,  
              easing: 'linear',
              offset: 0.58
            },
            {
              translateY: -125,  
              easing: 'linear',
              offset: 0.6
            },
            {
              translateY: -130,  
              easing: 'linear',
              offset: 0.63
            },
            {
              translateY: -128,  
              easing: 'linear',
              offset: 0.69
            },
            {
              translateY: -120,  
              easing: 'linear',
              offset: 0.75
            },
    
            {
              translateY: -118,  
              easing: 'linear',
              offset: 0.78
            },
            {
              translateY: -117,  
              easing: 'linear',
              offset: 0.785
            },
            {
              translateY: -116,  
              easing: 'linear',
              offset: 0.787
            },
     
            {
              easing: 'linear',
              translateY: -95, 
              offset: 0.81  
            },
            {
              easing: 'linear',
              translateY: -90, 
              offset: 0.85  
            },
     
            {
              easing: 'linear',
              translateY: -84, 
              offset: 0.9 
            },
    
          ],
        });
      };

      // Second Animation
      const animationTwo = (target) => {
        anime.timeline().add({
          targets: target,
          duration: 10000,
          keyframes: [
            {
              translateY: -167,  
              opacity: 1,
              easing: 'linear', 
              offset: 0.1
            },
            {
              translateY: -165,  
              easing: 'linear',  
              offset: 0.11
            },
            {
              translateY: -140,  
              easing: 'linear',
              offset: 0.12
            },
            {
              translateY: -140,  
              easing: 'linear',
              offset: 0.13
            },
            {
              translateY: -143,  
              easing: 'linear',
              offset: 0.14
            },
            {
              translateY: -143,  
              easing: 'linear',
              offset: 0.2
            },
            {
              translateY: -143,  
              easing: 'linear',
              offset: 0.3
            },
            {
              translateY: -153,  
              easing: 'linear',
              offset: 0.4
            },
            {
              translateY: -140,  
              easing: 'linear',
              offset: 0.5
            },
            {
              translateY: -130,  
              easing: 'linear',
              offset: 0.55
            },
            {
              translateY: -120,  
              easing: 'linear',
              offset: 0.58
            },
            {
              translateY: -145,  
              easing: 'linear',
              offset: 0.6
            },
            {
              translateY: -130,  
              easing: 'linear',
              offset: 0.63
            },
            {
              translateY: -128,  
              easing: 'linear',
              offset: 0.69
            },
            {
              translateY: -120,  
              easing: 'linear',
              offset: 0.75
            },
    
            {
              translateY: -118,  
              easing: 'linear',
              offset: 0.78
            },
            {
              translateY: -117,  
              easing: 'linear',
              offset: 0.785
            },
            {
              translateY: -116,  
              easing: 'linear',
              offset: 0.787
            },
            {
              easing: 'linear',
              translateY: -95, 
              offset: 0.81  
            },
            {
              easing: 'linear',
              translateY: -90, 
              offset: 0.85  
            },
     
            {
              easing: 'linear',
              translateY: -84, 
              offset: 0.9 
            },
    
          ],
        });
      };

      const animationThree = (target) => {
        anime.timeline().add({
          targets: target,
          duration: 10000,
          keyframes: [
            {
              translateY: -167,  
              opacity: 1,
              easing: 'linear', 
              offset: 0.1
            },
            {
              translateY: -165,  
              easing: 'linear',  
              offset: 0.11
            },
            {
              translateY: -160,  
              easing: 'linear',
              offset: 0.12
            },
            {
              translateY: -160,  
              easing: 'linear',
              offset: 0.13
            },
            {
              translateY: -163,  
              easing: 'linear',
              offset: 0.14
            },
            {
              translateY: -163,  
              easing: 'linear',
              offset: 0.2
            },
            {
              translateY: -163,  
              easing: 'linear',
              offset: 0.3
            },
            {
              translateY: -153,  
              easing: 'linear',
              offset: 0.4
            },
            {
              translateY: -150,  
              easing: 'linear',
              offset: 0.5
            },
            {
              translateY: -150,  
              easing: 'linear',
              offset: 0.55
            },
            {
              translateY: -150,  
              easing: 'linear',
              offset: 0.58
            },
            {
              translateY: -155,  
              easing: 'linear',
              offset: 0.6
            },
            {
              translateY: -150,  
              easing: 'linear',
              offset: 0.63
            },
            {
              translateY: -158,  
              easing: 'linear',
              offset: 0.69
            },
            {
              translateY: -150,  
              easing: 'linear',
              offset: 0.75
            },
    
            {
              translateY: -151,  
              easing: 'linear',
              offset: 0.78
            },
            {
              translateY: -137,  
              easing: 'linear',
              offset: 0.785
            },
            {
              translateY: -126,  
              easing: 'linear',
              offset: 0.787
            },
            {
              easing: 'linear',
              translateY: -95, 
              offset: 0.81  
            },
            {
              easing: 'linear',
              translateY: -90, 
              offset: 0.85  
            },
     
            {
              easing: 'linear',
              translateY: -84, 
              offset: 0.9 
            },
    
          ],
        });
      };


      const animationFour = (target) => {
        anime.timeline().add({
          targets: target,
          duration: 10000,
          keyframes: [
            {
              translateY: -167,  
              opacity: 1,
              easing: 'linear', 
              offset: 0.1
            },
            {
              translateY: -167,  
              easing: 'linear',  
              offset: 0.11
            },
            {
              translateY: -167,  
              easing: 'linear',
              offset: 0.12
            },
            {
              translateY: -167,  
              easing: 'linear',
              offset: 0.13
            },
            {
              translateY: -167,  
              easing: 'linear',
              offset: 0.14
            },
            {
              translateY: -167,  
              easing: 'linear',
              offset: 0.2
            },
            {
              translateY: -167,  
              easing: 'linear',
              offset: 0.3,
              skewX: 10, 
              skewY: -5,  
            },
            {
              translateY: -163,  
              easing: 'linear',
              offset: 0.4
            },
            {
              translateY: -130,  
              easing: 'linear',
              offset: 0.5
            },
            {
              translateY: -127,  
              easing: 'linear',
              offset: 0.55
            },
            {
              translateY: -125,  
              easing: 'linear',
              offset: 0.58
            },
            {
              translateY: -121,  
              easing: 'linear',
              offset: 0.6
            },
            {
              translateY: -118,  
              easing: 'linear',
              offset: 0.63
            },
            {
              translateY: -115,  
              easing: 'linear',
              offset: 0.69
            },
            {
              translateY: -110,  
              easing: 'linear',
              offset: 0.75
            },
    
            {
              translateY: -107,  
              easing: 'linear',
              offset: 0.78
            },
            {
              translateY: -105,  
              easing: 'linear',
              offset: 0.785
            },
            {
              translateY: -102,  
              easing: 'linear',
              offset: 0.787
            },
            {
              easing: 'linear',
              translateY: -95, 
              offset: 0.81  
            },
            {
              easing: 'linear',
              translateY: -90, 
              offset: 0.85  
            },
     
            {
              easing: 'linear',
              translateY: -84, 
              offset: 0.9 
            },
    
          ],
        });
      };

      // Apply a random animation to each ball
      balls.forEach((ball) => animateBall(ball));

 

    // tl.add({
    //   targets: [".layer-2", ".layer-4", ".ball-container"],
    //   rotate: "+=30",
    //   duration: 1000,  
    //   easing: "linear",
    // });
  };

  // Optional local test button
  handleSpinClick = () => {
    const randomNumber = Math.floor(Math.random() * 37); // local test
    // this.spinWheel(randomNumber);
    this.updateNum(randomNumber);
    this.spinWheel(randomNumber); // 1);
    console.log("Local test spin, number:", randomNumber);
  };

  // 6) Evaluate the winning number vs user bets
  updateNum = (num) => {
    this.setState({ num, count: this.state.count + 1 });

    // Example: if you store bets in state.arr
    // We'll check each bet for a match
    let didWin = false;
    this.state.arr.forEach(item => {
      // A) Single number bet
      if (item === num) {
        didWin = true;
        this.userWin(35);
      }
      // B) Array bet (splits, corners, basket, etc.)
      else if (Array.isArray(item)) {
        // If it's 4 numbers and includes 'num' => basket bet
        if (item.length === 4 && item.includes(num.toString())) {
          // typical is 6:1 or 8:1; adjust as you like
          didWin = true;
          this.userWin(6);
        }
        // or 2-split, 3-street, etc.
        // if (item.length === 2 && item.includes(num.toString())) {
        //   didWin = true;
        //   this.userWin(17);
        // }
        // ...
      }
      // C) Named bets, e.g. "Basket"
      else if (typeof item === "string") {
        if (item === "Basket") {
          // Check if the winning num is in basketBet
          if (this.basketBet.includes(num.toString())) {
            didWin = true;
            this.userWin(6);
          }
        }
        // else if (item === "Even" && this.even.includes(num)) { ... }
        // etc...
      }
    });

    if (!didWin) {
      this.userLost();
    }
  };

  // 7) userLost / userWin / resetGame

  userLost = () => {
    this.setState(
      {
        message: `No luck this time!`,
        losses: this.state.losses + 1,
      },
      () => {
        this.resetGame();
      }
    );
  };

  userWin = (multi) => {
    const winCoins = multi * parseInt(this.state.chip);
    this.setState(
      {
        message: `You win ${winCoins} coins!`,
        wins: this.state.wins + 1,
        coins: this.state.coins + winCoins,
      },
      () => {
        this.resetGame();
      }
    );
  };

  resetGame = () => {
    // Clear bets, reset wheel, etc.
    this.setState({
      arr: [],
      spinning: false,
      num: "",
      // Reset your row JSON if needed
      firstRow: firstRow.map(num => ({ ...num, visible: false })),
      firstBorder: firstBorder.map(num => ({ ...num, visible: false })),
      secondRow: secondRow.map(num => ({ ...num, visible: false })),
      secondBorder: secondBorder.map(num => ({ ...num, visible: false })),
      thirdRow: thirdRow.map(num => ({ ...num, visible: false })),
      thirdBorder: thirdBorder.map(num => ({ ...num, visible: false })),
      fourthRow: fourthRow.map(num => ({ ...num, visible: false })),
      fifthRow: fifthRow.map(num => ({ ...num, visible: false })),
      columnLeft: columnLeft.map(num => ({ ...num, visible: false })),
      columnRight: columnRight.map(num => ({ ...num, visible: false })),
    });
  };

  formatCurrency = (value) => {
    if (typeof value !== "number") {
      return '-'; // throw new Error("Input must be a number");
    }
  
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  getNumberColor = (number) => {
    const matchedData = options.find(d => d.number === number);
    return matchedData && matchedData.color;
  }


  // Render
  render() {
    // progress bar logic
    const percentage = Math.max((this.state.progressPerc / 165) * 97, -5).toFixed(0);
    // const { isMuted, wheelInfoTxt, timer, progressPerc } = this.state;

    // If not loaded, show some loader screen
    if (!this.state.isLoaded) {
      return (
        <>
          <div className="wheelPage-singleZero">
            <div className="load-screen-background">
              <div className="timer-img">
                <div className="timer-text">
                  <span>{this.state.bgTimer}</span>
                </div>
              </div>
              <div className="load-screen__title">CURRENT GAME IN SESSION.</div>
              <div className="load-screen__roullet"></div>
              {/* <div className="load-screen__jec-pot"></div> */}
            </div>
          </div>
        </>
      );
    }

    return (
      <>
      <div className="wheelPage-singleZero">
        <div className="wheel">
          <div className="wheel__left">
            <div className="wheel__left-margin">
              <div className="spin-wrap">
                <div className="spin-border">
                  {/* Top spin lights */}
                  <div className="spin-light spin-light-top">
                    <div className="spin-light-container">
                      {Array.from({ length: 15 }).map((_, index) => (
                        <div
                          className="spin-light-item"
                          style={{ animationDelay: `${index * 0.2}s` }}
                          key={index}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Center spin number */}
                  <div className="spin-number">
                    <div className="spin-number__text">
                      <span className="spin-number__text-big">SPIN</span>
                      <span className="spin-number__text-littel">NUMBER</span>
                    </div>
                    <div className="span-number__number">{this.state.currentSpinId}</div>
                  </div>

                  {/* Bottom spin lights */}
                  <div className="spin-light spin-light-bottom">
                    <div className="spin-light-container">
                      {Array.from({ length: 15 }).map((_, index) => (
                        <div
                          className="spin-light-item"
                          style={{ animationDelay: `${index * 0.2}s` }}
                          key={index}
                        />
                      ))}
                    </div>
                  </div>
                </div>

                <div className="spin-wheel-bottom">
                  <div className="spin-wheel-bottom__left">
                    <div className="wheel-spin-number">
                      {this.state.betsLogL.map((item, index) => {
                        const matchedData = options.find(d => d.number === item.number);
                        const winNumberColor = matchedData ? matchedData.color : 'black';
                        return (
                          <div key={item.spinId} className="wheel-spin-number__item">
                            <div className="wheel-spin-number__spin">{item.spinId}</div>
                            <div
                              className="wheel-spin-number__number"
                              style={{
                                background: winNumberColor,
                                '--pulse-delay': `${index * 0.3}s`,
                              }}
                            >
                              {item.number}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="spin-wheel-bottom__right">
                    <div className="wheel-spin-number">
                      {this.state.betsLogR.map((item) => {
                        const matchedData = options.find(d => d.number === item.number);
                        const winNumberColor = matchedData ? matchedData.color : 'black';
                        return (
                          <div key={item.spinId} className="wheel-spin-number__item">
                            <div className="wheel-spin-number__spin">{item.spinId}</div>
                            <div
                              className="wheel-spin-number__number"
                              style={{ background: winNumberColor }}
                            >
                              {item.number}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              <div className="numbers numbers--compact">
                <div className="numbers__title color-hot">HOT NUMBERS</div>
                  <div className="numbers__row background-hot">
                    <div
                      className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.hot1)} ${this.getNumberColor(this.state.hot1) === 'red' ? 'hot' : this.getNumberColor(this.state.hot1) === 'black' ? 'hot' : (this.getNumberColor(this.state.hot1) === 'green' ? 'hot' : '') }`}
                      style={{ animationDelay: '0s' }}
                    >
                      {this.state.hot1}
                    </div>
                    <div
                      className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.hot2)} ${this.getNumberColor(this.state.hot2) === 'red' ? 'hot' : this.getNumberColor(this.state.hot2) === 'black' ? 'hot' : (this.getNumberColor(this.state.hot2) === 'green' ? 'hot' : '') }`}
                      style={{ animationDelay: '0.2s' }}
                    >
                      {this.state.hot2}
                    </div>
                    <div
                      className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.hot3)} ${this.getNumberColor(this.state.hot3) === 'red' ? 'hot' : this.getNumberColor(this.state.hot3) === 'black' ? 'hot' : (this.getNumberColor(this.state.hot3) === 'green' ? 'hot' : '') }`}
                      style={{ animationDelay: '0.4s' }}
                    >
                      {this.state.hot3}
                    </div>
                    <div
                      className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.hot4)} ${this.getNumberColor(this.state.hot4) === 'red' ? 'hot' : this.getNumberColor(this.state.hot4) === 'black' ? 'hot' : (this.getNumberColor(this.state.hot4) === 'green' ? 'hot' : '') }`}
                      style={{ animationDelay: '0.6s' }}
                    >
                      {this.state.hot4}
                    </div>
                    <div
                      className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.hot5)} ${this.getNumberColor(this.state.hot5) === 'red' ? 'hot' : this.getNumberColor(this.state.hot5) === 'black' ? 'hot' : (this.getNumberColor(this.state.hot5) === 'green' ? 'hot' : '') }`}
                      style={{ animationDelay: '0.8s' }}
                    >
                      {this.state.hot5}
                    </div>
                </div>
 
              </div>

              <div className="numbers numbers--compact">
                <div className="numbers__title color-cool">COLD NUMBERS</div>
                <div className="numbers__row background-cool">
                  <div className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.cold1)} ${this.getNumberColor(this.state.cold1) === 'red' ? 'cold' : this.getNumberColor(this.state.cold1) === 'black' ? 'cold' : (this.getNumberColor(this.state.cold1) === 'green' ? 'cold' : '')}`}style={{ animationDelay: '0.2s' }}>{this.state.cold1}</div>
                  <div className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.cold2)} ${this.getNumberColor(this.state.cold2) === 'red' ? 'cold' : this.getNumberColor(this.state.cold2) === 'black' ? 'cold' : (this.getNumberColor(this.state.cold2) === 'green' ? 'cold' : '')} `}style={{ animationDelay: '0.4s' }}>{this.state.cold2}</div>
                  <div className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.cold3)} ${this.getNumberColor(this.state.cold3) === 'red' ? 'cold' : this.getNumberColor(this.state.cold3) === 'black' ? 'cold' : (this.getNumberColor(this.state.cold3) === 'green' ? 'cold' : '')} `}style={{ animationDelay: '0.6s' }}>{this.state.cold3}</div>
                  <div className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.cold4)} ${this.getNumberColor(this.state.cold4) === 'red' ? 'cold' : this.getNumberColor(this.state.cold4) === 'black' ? 'cold' : (this.getNumberColor(this.state.cold4) === 'green' ? 'cold' : '')} `}style={{ animationDelay: '0.8s' }}>{this.state.cold4}</div>
                  <div className={`numbers__col numbers__col--pulse col-hotcold-${this.getNumberColor(this.state.cold5)} ${this.getNumberColor(this.state.cold5) === 'red' ? 'cold' : this.getNumberColor(this.state.cold5) === 'black' ? 'cold' : (this.getNumberColor(this.state.cold5) === 'green' ? 'cold' : '')} `}style={{ animationDelay: '1s' }}>{this.state.cold5}</div>
                </div>
 
              </div>

              <div className="top-position-jackpot">
                <JackpotSVG animOn={this.state.animJackpotOn} restartOnPlay />
                <MiniJackpotAmount
                  formattedMegaJackpot={this.formatCurrency(this.state.megaJackpot)}
                  formattedMiniJackpot={this.formatCurrency(this.state.miniJackpot)}
                />
                <div className="wheel-jackpot-current1">
                  <div className="wheel-jackpot-current-text">MINI JACKPOT</div>
                </div>
              </div>


            </div>
          </div>




          {/* Middle wheel */}
          <div className="wheel__middel">
            <div className="wheel-loader__bor">
              <div className="wheel-loader__text">{this.state.wheelInfoTxt}</div>
              <div className="wheel-loader">
                <div className="wheel-ball__line"
                  style={{ width: `${percentage}%`}}
                ></div>
                
                {/* <div
                  className="wheel-loader__boll"
                  style={{ left: `${percentage}%`, transition: "left 1.5s ease" }}
                ></div> */}
              </div>
            </div>
            

          



            <div className="wheel-jackpot-wrapper">
            <div className="roulette-wheel">
              {/* Layers that spin */}
              <div className="layer-2 wheel" style={{ transform: "rotate(0deg)" }}></div>
              <div className="layer-4 wheel" style={{ transform: "rotate(0deg)" }}></div>

              {/* Ball container */}
              <div className="ball-container" style={{ transform: "rotate(0deg)" }}>
                <div
                  className="ball"
                  style={{
                    transform: "translateY(-163px)",
                    opacity: 0
                  }}
                ></div>
              </div>

              {/* Optional test button */}
              {/* <button className="btn-spin" onClick={this.handleSpinClick}>
                Spin (local test)
              </button> */}

              {/* <audio ref={this.audioRef} src="https://www.myinstants.com/media/sounds/slot-machine.mp3" /> */}
            </div>



            </div>
          </div>

          <div className="wheel__right">
            <div className="spin-wrap">
              <div className="spin-border">
                {/* Top spin lights */}
                <div className="spin-light spin-light-top">
                  <div className="spin-light-container">
                    {Array.from({ length: 15 }).map((_, index) => (
                      <div
                        className="spin-light-item"
                        style={{ animationDelay: `${index * 0.2}s` }}
                        key={index}
                      />
                    ))}
                  </div>
                </div>

                {/* Center spin number */}
                <div className="spin-number spin-number-lucky">
                  <div className="spin-number__text">
                    <span className="spin-number__text-big">LUCKY</span>
                    <span className="spin-number__text-littel">NUMBER</span>
                  </div>
                  <div className="span-number__number span-number__number-lucky">{this.state.luckyNumberText}</div>
                </div>

                {/* Bottom spin lights */}
                <div className="spin-light spin-light-bottom">
                  <div className="spin-light-container">
                    {Array.from({ length: 15 }).map((_, index) => (
                      <div
                        className="spin-light-item"
                        style={{ animationDelay: `${index * 0.2}s` }}
                        key={index}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <div className="spin-wheel-bottom">
                <div className="spin-wheel-bottom__left">
                  <div className="wheel-spin-number">
                    {this.state.luckyArrL.map((item, index) => {
                      const matchedData = options.find(d => d.number === item.number);
                      const winNumberColor = matchedData ? matchedData.color : 'black';
                      return (
                        <div key={item.spinId} className="wheel-spin-number__item">
                          <div className="wheel-spin-number__spin">{item.spinId}</div>
                          <div
                            className="wheel-spin-number__number"
                            style={{
                              background: winNumberColor,
                              '--pulse-delay': `${index * 0.3}s`,
                            }}
                          >
                            {item.number}

                          </div>
                             <div className="lucky-num-type">{item.jackpotType}</div>

                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="spin-wheel-bottom__right">
                  <div className="wheel-spin-number">
                    {this.state.luckyArrR.map((item) => {
                      const matchedData = options.find(d => d.number === item.number);
                      const winNumberColor = matchedData ? matchedData.color : 'black';
                      return (
                        <div key={item.spinId} className="wheel-spin-number__item">
                          <div className="wheel-spin-number__spin">{item.spinId}</div>
                          <div
                            className="wheel-spin-number__number"
                            style={{ background: winNumberColor }}
                          >
                            {item.number}
                          </div>
                             <div className="lucky-num-type">{item.jackpotType}</div>

                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div className="wheel-jackpot">
              <div className="wheel-jackpot-winners">
                <div className="spin-border-winners">
                  {/* Top spin lights */}
                  <div className="spin-light spin-light-top">
                    <div className="spin-light-container">
                      {Array.from({ length: 13 }).map((_, index) => (
                        <div
                          className="spin-light-item"
                          style={{ animationDelay: `${index * 0.2}s` }}
                          key={index}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Center spin number */}
                  <div className="spin-number-winners">
                    {/* <div className="spin-number-winners__header">
                      <span className="spin-number-winners__header-label">LUCKY NUMBER</span>
                      <span className="spin-number-winners__header-value">{this.state.currentSpinId}</span>
                    </div> */}

                    <div className="spin-light spin-light-mid">
                      {/* <div className="spin-light-container">
                        {Array.from({ length: 15 }).map((_, index) => (
                          <div
                            className="spin-light-item"
                            style={{ animationDelay: `${index * 0.2}s` }}
                            key={index}
                          />
                        ))}
                      </div> */}
                    </div>

                    <div className="spin-number-winners__number">WINNERS</div>
                    {/* <div className="spin-number-winners__number lucky-num-text">{this.state.luckyNumberText}</div> */}
                    <div className="span-li-item">
                    </div>

                    {this.state.winners.map((winner, index) => (
                      <div className="span-li-item" key={index}>
                        <div className="span-li-item-name">SPIN {winner.spinNumber} - {winner.jackpotType} {winner.luckyNumber}</div>

                        {winner.shops.map((shop, index) => (
                          <div className="span-li-item-amount">{shop.ticketsCount}x {shop.shopName} ${winner.jackpotAmountPerTicket}</div>
                        ))}
                      </div>
                    ))}
                    {!this.state.winners.length &&
                      (<div className="span-li-item-name">Play now and be the first to win the MEGA and MINI jackpots</div>)}
                  </div>

                  {/* Bottom spin lights */}
                  <div className="spin-light spin-light-bottom">
                    <div className="spin-light-container">
                      {Array.from({ length: 13 }).map((_, index) => (
                        <div
                          className="spin-light-item"
                          style={{ animationDelay: `${index * 0.2}s` }}
                          key={index}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



        




          {/* Ball sound audio ref */}
          <audio ref={this.ballAudioRef} src={sound} />
        </div>

        {/* Example usage of your table or not */}
        <Container className="cont">
          <Row className="justify-items-center pt-2">

          </Row>
        </Container>
      </div>
      </>
    );
  }
}

export default App;
